module.exports = __webpack_public_path__ + "media/images/video/stride-app-promo-d4bd21d5b1859af571cc67c78acd2fa9.png";